module.exports = __webpack_public_path__ + "img/high-school-volunteer-list.215b6caa.png";